import { configureStore, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

interface ContextObject {
  name: string;
  contextObjectProp?: any; // Adjust type as needed
  mode?: string | null;
}

interface ContextState {
  contextObject: {};
}

const initialState: ContextState = {
  contextObject: {},
};

// Create a slice of the state
const contextSlice = createSlice({
  name: 'context',
  initialState,
  reducers: {
    setContextObject(state, action: PayloadAction<{}>) {
      state.contextObject = action.payload;
    },
    resetContextObject(state) {
      state.contextObject = {};
    },
  },
});

// Export the actions
export const { setContextObject, resetContextObject } = contextSlice.actions;

// Create the store
const store = configureStore({
  reducer: {
    contextSlice: contextSlice.reducer,
  },
});

// Define RootState and AppDispatch types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export hooks for usage in functional components
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;